module.exports = __webpack_public_path__ + "static/media/h .44c0c46f.svg";